import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { RootState } from '../../redux/store';
import { GetInvoiceListPagingAndFilterResponse, GetInvoiceListPagingAndFilterResponseData, GetInvoiceListPagingAndFilterResponseItem, initialGetInvoiceListPagingAndFilterResponseData } from '../../models/response/invoice/GetInvoiceListPagingAndFilterResponse';
import { GetInvoiceListPagingAndFilterRequest, initialGetInvoiceListPagingAndFilterRequest } from '../../models/request/invoice/GetInvoiceListPagingAndFilterRequest';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../ColumnFilter/kolonBirlestir';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import { storeActivityIndicator, storeAreYouSureModalCallback, storeEbbeModalCallback } from '../../redux/reducers/authSlice';
import TableFooter from '../TableFooter';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTIcon } from '../../_metronic/helpers/components/KTIcon';
import { InvoiceService } from '../../services/InvoiceService';
import { Helpers } from '../../helpers/Helpers';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import RefreshButton from '../../components/RefreshButton';
import CommonInvoiceListFilters from './Components/CommonInvoiceListFilters';
import { ExportInvoiceListResponse } from '../../models/response/invoice/ExportInvoiceListResponse';
import { DeleteInvoiceResponse } from '../../models/response/invoice/DeleteInvoiceResponse';
import { UyumsoftService } from '../../services/UyumsoftService';
import { SendInvoiceResponse } from '../../models/response/uyumsoft/SendInvoiceResponse';
import { CancelDraftInvoiceResponse } from '../../models/response/uyumsoft/CancelDraftInvoiceResponse';
import { MoveToDraftInvoiceResponse } from '../../models/response/uyumsoft/MoveToDraftInvoiceResponse';
import ColumnFilterRow from '../ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode, loadList } from '../ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import StatusBadge from '../StatusBadge';
import { CompanyService } from '../../services/CompanyService';
import { buildExcelRequest, ExcelExportMode } from '../../helpers/excelExportRequest';

interface Props {
    pageName: string
    pageVersion: string
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
}

/** E-fatura durumları (sunucudaki FaturaDurumAdi ile aynı adlar). */
const FATURA_TURLERI = ['e-Fatura', 'e-Arşiv'];
const EFATURA_DURUMLARI = ['Taslak', 'Kuyrukta', 'İşleniyor', "GİB'e Gönderildi", 'Onay Bekliyor', 'Onaylandı', 'Reddedildi', 'İade', 'İptal', 'Hata'];

const CommonInvoiceList = ({ pageName, pageVersion, isSale, isPurchase, isRefund }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const [data, setData] = useState<GetInvoiceListPagingAndFilterResponseData>(initialGetInvoiceListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetInvoiceListPagingAndFilterRequest>({
        ...initialGetInvoiceListPagingAndFilterRequest,
        isSale: isSale,
        isPurchase: isPurchase,
        isRefund: isRefund
    })

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Fatura Durumu', name: 'invoiceStatusName', order: 0, isVisible: true },
            // Uyumsoft'taki gercek durum (07.10.2026): Taslak, Kuyrukta, Hata, GIB'e Gonderildi ...
            { title: 'E-Fatura Durumu', name: 'efaturaStatusName', order: 0, isVisible: true },
            { title: 'Fatura Türü', name: 'faturaTuru', order: 0, isVisible: true },
            { title: 'Cari Ünvanı', name: 'currentCompanyName', order: 0, isVisible: true },
            { title: 'Fatura Tarihi', name: 'invoiceDateStr', order: 0, isVisible: true },
            { title: 'Fatura Seri/No', name: 'serialNo', order: 0, isVisible: true },
            { title: 'Operasyon Türü', name: 'operationTypeName', order: 0, isVisible: true },
            { title: 'Aktarım Tarihi', name: 'transferDateStr', order: 0, isVisible: true },
            { title: 'Ödeme Şekli', name: 'paymentTypeName', order: 0, isVisible: true },
            { title: 'Ödeme Vadesi', name: 'maturityPeriodName', order: 0, isVisible: true },
            { title: 'Ödeme Tarihi', name: 'paymentDateStr', order: 0, isVisible: true },
            // Toplam Tutar KDV hariç; Brüt Toplam = Toplam Tutar + KDV - Tevkifat (01.11.2026, Burak: ikisi ters bağlıydı).
            { title: 'Toplam Tutar', name: 'totalWithoutTaxPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'KDV Tutarı', name: 'taxPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Tevkifat Tutarı Toplamı', name: 'withholdingPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Brüt Toplam', name: 'totalPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Yerel Toplam Tutar', name: 'localTotalWithoutTaxPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Yerel KDV Tutarı', name: 'localTaxPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Yerel Tevkifat Toplam', name: 'localWithholdingPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Yerel Brüt Toplam', name: 'localTotalPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    // Üst bardaki e-Fatura ikonundan gelindiyse liste o filtreyle açılır; liste zaten açıkken tıklanınca da
    // (location.key) filtre uygulanır. Filtresiz gelişte yalnız ilk açılışta veri çekilir (07.10.2026).
    const location = useLocation();
    const gelenFiltreler: ColumnFilterModel[] | undefined = (location.state as any)?.columnFilters;
    const ilkAcilis = useRef(true);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    useEffect(() => {
        if (gelenFiltreler && gelenFiltreler.length > 0)
            getData({ ...filter, columnFilters: gelenFiltreler, currentPage: 1, skip: 0 });
        else if (ilkAcilis.current)
            getData();

        ilkAcilis.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key])

    const deleteInvoice = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.invoiceId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteInvoiceResponse = await InvoiceService.deleteInvoice(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateInvoice = async (_id: string | undefined = undefined) => {
        navigate(`/${(isSale ? 'sale' : isPurchase ? 'purchase' : isRefund ? 'refund' : '')}invoice/listadd?id=` + (_id ? _id : data.items.filter(x => x.isSelected)[0].invoiceId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetInvoiceListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true));

            var response: GetInvoiceListPagingAndFilterResponse = await InvoiceService.getInvoiceListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);

            // E-Fatura Durumu: ekrandaki sonuçlanmamış faturalar arkada Uyumsoft'tan yenilenir (liste beklemez).
            UyumsoftService.refreshStatusesArkada(
                response.data.items.filter(x => !['GİB\'e Gönderildi', 'Onaylandı', 'Reddedildi', 'İade', 'İptal', 'İptal (e-Arşiv)'].includes(x.efaturaStatusName ?? '')).map(x => x.invoiceId),
                []);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Tutar kolonları (toplam, KDV, brüt
    // ve yerel karşılıkları) fatura satırlarından hesaplandığı, yani veritabanında
    // karşılığı olan tek bir alan olmadığı için listede yok.
    const sortableColumns = [
        'refNo', 'invoiceStatusName', 'efaturaStatusName', 'faturaTuru', 'currentCompanyName', 'invoiceDateStr',
        'serialNo', 'operationTypeName', 'transferDateStr', 'paymentTypeName', 'maturityPeriodName',
        'paymentDateStr', 'currencyTypeName', 'description', 'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Cari Ünvanı kolonunun seçenekleri: eski filtre panelindeki gibi müşteri, acente ve
    // tedarikçi firmalar birlikte (bir firma birden çok listede olabilir).
    const loadInvoiceCompanies = async (): Promise<ColumnFilterOption[]> => {
        const lists = await Promise.all([
            loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name),
            loadList(CompanyService.getCompanyList({ isAgency: true }), 'companyId', x => x.name),
            loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name),
        ]);

        return lists.flat().filter((x, i, all) => all.findIndex(a => a.value == x.value) == i);
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (InvoiceManager.ApplyColumnFilters) aynı. Tutar kolonları fatura satırlarından
    // hesaplandığı için filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        invoiceStatusName: { type: 'select', loadOptions: () => loadConstants('INVOICE_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        // E-Fatura Durumu: adlar sunucudaki UyumsoftIntegrationManager.FaturaDurumAdi ile ayni; "(Boş)" = Uyumsoft'a gönderilmemiş.
        efaturaStatusName: { type: 'select', loadOptions: () => Promise.resolve(EFATURA_DURUMLARI.map(x => ({ value: x, label: x }))), renderOption: (label) => <StatusBadge text={label} /> },
        // Fatura Türü: sunucuda Uyumsoft numarasından (MER = e-Arşiv); "(Boş)" = henüz Uyumsoft'a gönderilmemiş.
        faturaTuru: { type: 'select', loadOptions: () => Promise.resolve(FATURA_TURLERI.map(x => ({ value: x, label: x }))) },
        currentCompanyName: { type: 'select', loadOptions: loadInvoiceCompanies },
        invoiceDateStr: { type: 'date' },
        serialNo: { type: 'text' },
        operationTypeName: { type: 'select', loadOptions: () => loadConstants('OPERATION_TYPE') },
        transferDateStr: { type: 'date' },
        paymentTypeName: { type: 'select', loadOptions: () => loadConstants('COMPANY_PAYMENT_TYPE') },
        maturityPeriodName: { type: 'select', loadOptions: () => loadConstants('COMPANY_MATURITY_PERIOD') },
        paymentDateStr: { type: 'date' },
        currencyTypeName: { type: 'select', loadOptions: () => loadConstantsByCode('CURRENCY') },
        description: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.invoiceId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportInvoiceListResponse = await InvoiceService.exportInvoiceList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.invoiceId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getColumnValue = (item: GetInvoiceListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.invoiceId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
            )
        }
        else if (column == "efaturaStatusName") {
            // Üzerine gelince hata nedeni ve son kontrol zamanı.
            const baslik = [item.efaturaStatusMessage, item.efaturaStatusDateStr ? 'Son kontrol: ' + item.efaturaStatusDateStr : ''].filter(x => x).join('\n');
            return (
                <td className={className} title={baslik} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}><StatusBadge text={item.efaturaStatusName} /></td>
            )
        }
        else if (column == "faturaTuru") {
            return (
                <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}>{item.faturaTuru ? <StatusBadge text={item.faturaTuru} /> : null}</td>
            )
        }
        else if (column == "invoiceStatusName") {
            return (
                <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}><StatusBadge text={item.invoiceStatusName} /></td>
            )
        }
        else if (['totalPrice', 'taxPrice', 'totalWithoutTaxPrice', 'withholdingPrice', 'localTotalPrice', 'localTaxPrice', 'localTotalWithoutTaxPrice', 'localWithholdingPrice'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}>{Helpers.correctPrice(item2[column])}</td>;
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.invoiceId)} onDoubleClick={() => updateInvoice(item.invoiceId)}>{item2[column]}</td>;
        }
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Faturanın kendi para
    // birimindeki tutarlar döviz bazında gelir ("1.250,00 TRY, 45,00 USD"); her döviz
    // alt alta yazılır. Yerel tutarlar tek para biriminde olduğu için düz toplamdır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (['totalPrice', 'taxPrice', 'totalWithoutTaxPrice', 'withholdingPrice'].includes(columnName)) {
            var totals2: any = totals;
            var text: string = (totals2 ? totals2[columnName] : '') ?? '';

            return (
                <td className={className}>
                    {text.split(', ').filter(x => x != '').map(x => <div>{x}</div>)}
                </td>
            );
        }

        if (['localTotalPrice', 'localTaxPrice', 'localTotalWithoutTaxPrice', 'localWithholdingPrice'].includes(columnName)) {
            var totals3: any = totals;

            return <td className={className}>{Helpers.correctPrice(totals3 ? totals3[columnName] : 0)}</td>;
        }

        return <td className={className}></td>;
    }

    // Göndermeden önce türü sorar ve onay ister (17.10.2026, Burak): alıcının e-Fatura posta kutusu yoksa fatura
    // e-Arşiv kesilir; kullanıcı neyin gideceğini görmeden göndermesin. Kural gönderimle aynı (sunucuda).
    const sendToUyumsoft = async (_sendToGib: boolean) => {
        var secili = data.items.filter(x => x.isSelected);

        if (secili.length == 0)
            return;

        var onizleme: any;
        try {
            dispatch(storeActivityIndicator(true))
            onizleme = await UyumsoftService.faturaTuruOnizle(secili[0].invoiceId);
        } catch (error: any) {
            toast.error(error)
            return;
        } finally {
            dispatch(storeActivityIndicator(false))
        }

        if (!onizleme.isSuccess || !onizleme.data?.isSucceded) {
            toast.error(onizleme.data?.message ?? onizleme.message, { duration: 8000 })
            return;
        }

        var tur: string = onizleme.data.faturaTuru;
        var alici: string = onizleme.data.aliciUnvan ?? secili[0].currentCompanyName ?? '';
        var nasil = _sendToGib ? 'GİB\'e gönderilecek' : 'Uyumsoft\'a taslak olarak kaydedilecek';

        dispatch(storeEbbeModalCallback({
            title: _sendToGib ? 'Faturayı GİB\'e gönder' : 'Uyumsoft\'a taslak kaydet',
            body: '',
            vurgu: tur == 'e-Arşiv'
                ? { renk: 'turuncu', baslik: 'e-Arşiv olarak gidecek', kalin: alici, metin: 'e-Fatura mükellefi değil. Fatura e-Arşiv olarak kesilecek ve ' + nasil + (_sendToGib ? '; e-posta adresi varsa PDF olarak da iletilecek.' : '.'), soru: 'Devam edilsin mi?' }
                : { renk: 'mavi', baslik: 'e-Fatura olarak gidecek', kalin: alici, metin: 'e-Fatura mükellefi. Fatura e-Fatura olarak ' + nasil + '.', soru: 'Devam edilsin mi?' },
            buttons: [
                { text: 'Vazgeç', btnClass: 'btn-warning' },
                { text: _sendToGib ? 'Gönder' : 'Taslak Kaydet', btnClass: 'btn-success', onClick: () => gonder(secili[0].invoiceId, _sendToGib) }
            ]
        }));
    }

    const gonder = async (_invoiceId: string, _sendToGib: boolean) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: SendInvoiceResponse = await UyumsoftService.sendInvoice(_invoiceId, _sendToGib);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    /**
     * Uyumsoft'ta hataya dusmus faturayi taslaga cevirir (07.10.2026, irsaliyedeki gibi). Geri cekmeden farki:
     * belge iptal edilmez, NUMARA KORUNUR; duzeltip ayni numarayla yeniden gonderilir.
     */
    const moveToDraftInvoice = async () => {
        try {
            var selectedItems = data.items.filter(x => x.isSelected);

            if (selectedItems.length == 0)
                return;

            dispatch(storeActivityIndicator(true))

            var response: MoveToDraftInvoiceResponse = await UyumsoftService.moveToDraftInvoice(selectedItems[0].invoiceId);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    // Gönderilmiş e-Arşiv faturasının iptali (17.10.2026, #451): geri alınamaz, onay penceresiyle.
    const cancelEArsivInvoice = () => {
        var secili = data.items.filter(x => x.isSelected);

        if (secili.length != 1)
            return;

        if (secili[0].faturaTuru != 'e-Arşiv') {
            toast.error('Seçilen fatura e-Arşiv değil. e-Fatura buradan iptal edilemez.');
            return;
        }

        dispatch(storeEbbeModalCallback({
            title: 'e-Arşiv faturasını iptal et',
            body: '',
            vurgu: { renk: 'kirmizi', baslik: 'Bu işlem geri alınamaz', kalin: (secili[0].serialNo && secili[0].serialNo != '-' ? secili[0].serialNo : secili[0].refNo) + ' (' + (secili[0].currentCompanyName ?? '') + ')', metin: 'numaralı e-Arşiv faturası Uyumsoft\'ta iptal edilecek.', soru: 'Devam edilsin mi?' },
            buttons: [
                { text: 'Vazgeç', btnClass: 'btn-warning' },
                {
                    text: 'İptal Et',
                    btnClass: 'btn-danger',
                    onClick: async () => {
                        try {
                            dispatch(storeActivityIndicator(true))

                            var response: CancelDraftInvoiceResponse = await UyumsoftService.cancelEArsivInvoice(secili[0].invoiceId);

                            if (!response.isSuccess) {
                                toast.error(response.message)
                                return;
                            }

                            if (response.data.isSucceded) {
                                toast.success(response.data.message)
                                getData();
                            }
                            else {
                                toast.error(response.data.message, { duration: 8000 })
                            }
                        } catch (error: any) {
                            toast.error(error)
                        } finally {
                            dispatch(storeActivityIndicator(false))
                        }
                    }
                }
            ]
        }));
    }

    const cancelDraftInvoice = async () => {
        try {
            var selectedItems = data.items.filter(x => x.isSelected);

            if (selectedItems.length == 0)
                return;

            dispatch(storeActivityIndicator(true))

            var response: CancelDraftInvoiceResponse = await UyumsoftService.cancelDraftInvoice(selectedItems[0].invoiceId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <CommonInvoiceListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    isSale={isSale}
                    isPurchase={isPurchase}
                    isRefund={isRefund}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    sendToUyumsoft={sendToUyumsoft}
                    cancelDraftInvoice={cancelDraftInvoice}
                    cancelEArsivInvoice={cancelEArsivInvoice}
                    eArsivSecili={data.items.filter(x => x.isSelected).length == 1 && data.items.find(x => x.isSelected)?.faturaTuru == 'e-Arşiv'}
                    moveToDraftInvoice={moveToDraftInvoice}
                    deleteFunction={deleteInvoice}
                    updateFunction={() => updateInvoice()}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.invoiceId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default CommonInvoiceList;